import React from 'react'
import styled from 'styled-components'

import JobOffersModal from 'spa/member/components/JobOffersModal'
import { Button } from 'spa/member/components/Button'
import { Input } from 'spa/member/components/Input'

export type SearchConditionSaveModalProps = {
  onClose: () => void,
}

const StyledContent = styled.div`
  padding: 20px;
  text-align: left;
`

const StyledText = styled.p`
  font-size: .875rem;
  line-height: 1.4875rem;
  font-weight: 700;
`

const StyledModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  padding: 20px;
  width: 100%;
  border-top: 1px solid ${props => props.theme.members.colors.silver._30};
  box-shadow: 0px -10px 20px 0px #0000000D;
`

const StyledButtonContainer = styled.div`
  width: 17rem;
  align-items: center;
  margin: 0 20px;

  > button {
    margin-bottom: 12px;
  }
`

const StyledButton = styled(Button)`
  ${props =>
    `
      background-color: ${props.theme.members.colors.orange._80};
      color: ${props.theme.members.colors.white};
    `
  }
`

const StyledLinkButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  color: ${props => props.theme.members.colors.silver._70};
  font-size: .75rem;
`

export const StyledSearchingBookmarkSaveModal: React.FC<SearchConditionSaveModalProps> = (props: SearchConditionSaveModalProps) => {
  return (
    <JobOffersModal modalTitle='保存する条件名の編集' onClose={props.onClose}>
      <StyledContent>
        <StyledText>条件名</StyledText>
        <Input name='name' placeholder='バックエンドエンジニア週3日' />
      </StyledContent>
      <StyledModalFooter>
        <StyledButtonContainer>
          <StyledButton type='submit'>保存する</StyledButton>
          <StyledLinkButton type='button' onClick={props.onClose}>キャンセル</StyledLinkButton>
        </StyledButtonContainer>
      </StyledModalFooter>
    </JobOffersModal>
  )
}
